module.exports = {

  title: '易农无忧',

}



// WEBPACK FOOTER //
// ./src/settings.js